module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAA6klEQVQ4T6XUgRGCIBQGYJggV2gD3YA2aAScoEZohEZog9qgRsgNbBL6fw88wgfJyd07QOG7B4jaOWeUUndEg9hSRkzuNUA2WI5a63etiPlM5In4IFqCDo0O8ahFI2xAMpbWBKLDuq1BU4wr+wH9g1WohIngGjSHZcESWsKKoH95QX1CHHj6Edagv5e+hsUehkF4YdG+Is6IALMe/BgeZJ+iIhhhxmfGgyL+Qp8oT/PGKkWlUw6ZTZi0rGgVCzT9DldjOXQGMYD7wWX9zUzYtznTAI4YxPtYjSWZ7tDveOUMGrzHfLCl8Odgv3pz3xgyGkOHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footer-email.png
// module id = 39EG
// module chunks = 0